const getElementSelectors = () => {
  const swipe_control = document.querySelector<HTMLElement>(
    '#swipe-sdk-container .swipe-control',
  );
  const swipeHandle = document.querySelector<HTMLElement>(
    '#swipe-sdk-container .swipe-ctr',
  );
  const swipeSDKFrame = document.querySelector<HTMLIFrameElement>(
    '#swipe-sdk-container #swipeSDKFrame',
  );
  const swipeSdkContainer = document.querySelector<HTMLDivElement>(
    '#swipe-sdk-container',
  );
  const dropdownMenu = document.querySelector<HTMLElement>(
    '#swipe-sdk-container .dropdown__menu',
  );
  const dropdown = document.querySelector<HTMLElement>(
    '#swipe-sdk-container .dropdown',
  );
  const dropdownToggle = document.querySelector<HTMLElement>(
    '#swipe-sdk-container .dropdown__toggle',
  );
  const swipeControlItem = document.getElementsByClassName(
    'swipe-control__item',
  )[1] as HTMLElement | undefined; // Second item in the collection, may not exist

  const dropDownItem = document.querySelectorAll<HTMLElement>(
    '#swipe-sdk-container .dropdown__item',
  );
  const dropDownOverlay = document.querySelector<HTMLElement>(
    '#swipe-sdk-container .swipe-sdk-overlay',
  );
  const swipeErrorMsg = document.querySelector<HTMLElement>(
    '#swipe-sdk-container .swipe_error_msg',
  );

  const loader__iconId = document.querySelector<HTMLElement>(
    '#swipe-sdk-container #loader__icon',
  );

  const topBar = document.querySelector<HTMLElement>(
    '#swipe-sdk-container .top-bar',
  );

  const drawer = document.querySelector<HTMLElement>(
    '#swipe-sdk-container .swipe-sdk-drawer',
  );

  const drawerOverlay = document.querySelector<HTMLElement>(
    '#swipe-sdk-container .drawer-overlay',
  );

  const ribbon = document.querySelector<HTMLElement>(
    '#swipe-sdk-container .swipe-sdk-ribbon',
  );

  const bgLayer = swipe_control?.querySelector(
    '.swipe-icons-bg-layer',
  ) as HTMLElement;

  const gradientLayer = swipe_control?.querySelector(
    '.swipe-icons-gradient-layer',
  ) as HTMLElement;

  const swipeIconClose = swipe_control?.querySelector(
    '.swipe-close-icon-wrapper',
  ) as HTMLElement;

  const swipeIconOpen = swipe_control?.querySelector(
    '#swipe-icon-open',
  ) as HTMLElement;

  const swipeControlWrapper = document.querySelector<HTMLElement>(
    '.swipe-control-wrapper',
  );

  return {
    swipe_control,
    swipeHandle,
    swipeSDKFrame,
    swipeSdkContainer,
    dropdownMenu,
    dropdown,
    dropdownToggle,
    swipeControlItem,
    dropDownItem,
    dropDownOverlay,
    swipeErrorMsg,
    loader__iconId,
    topBar,
    drawer,
    drawerOverlay,
    ribbon,
    bgLayer,
    gradientLayer,
    swipeIconClose,
    swipeIconOpen,
    swipeControlWrapper,
  };
};

export default getElementSelectors;
